<h1 [innerHTML]="text | translate"
    class="_300"></h1>
<p [innerHTML]="descriptions | translate:translateParams"
   class="text-muted _300"></p>
